import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { mapTranslatedOptions } from '@common/helpers/helpers';

const useTranslatedOptions = () => {
  const { t } = useTranslation();
  return useMemo(mapTranslatedOptions(t), []);
};

export default useTranslatedOptions;
